import React from 'react';
import { useTranslation } from 'react-i18next';

const BookSearchForm = ({ filterType, onFilterChange, keyword, onKeywordChange, address, onAddressChange, addressRef, onClearAddress, onSearch }) => {
  const { t } = useTranslation();

  return (
    <div className="bg-white/95 backdrop-blur-sm rounded-2xl shadow-lg p-5 sm:p-6 border border-white/20 max-w-5xl mx-auto">
      <div className="flex flex-col lg:flex-row gap-4 items-stretch lg:items-center">
        <div className="w-full lg:flex-1">
          <div className="inline-flex rounded-lg shadow-sm w-full" role="group">
            <button
              type="button"
              className={`w-full px-4 py-3 text-sm font-medium rounded-l-lg border transition-all duration-200 ${
                filterType === 'C'
                  ? 'text-white border-transparent bg-[var(--feel-primary)]'
                  : 'text-gray-700 border-gray-200 hover:text-white hover:bg-[var(--feel-primary)] bg-white'
              }`}
              onClick={() => onFilterChange('C')}
            >
              {t('GENERAL.centers')}
            </button>
            <button
              type="button"
              className={`w-full px-4 py-3 text-sm font-medium rounded-r-lg border transition-all duration-200 ${
                filterType === 'P'
                  ? 'text-white border-transparent bg-[var(--feel-primary)]'
                  : 'text-gray-700 border-gray-200 hover:text-white hover:bg-[var(--feel-primary)] bg-white'
              }`}
              onClick={() => onFilterChange('P')}
            >
              {t('GENERAL.professionals')}
            </button>
          </div>
        </div>

        <div className="w-full lg:flex-1">
          <div className="relative">
            <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
              <svg className="w-5 h-5 text-gray-500" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
                <path
                  fillRule="evenodd"
                  d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                  clipRule="evenodd"
                />
              </svg>
            </div>
            <input
              type="text"
              className="block w-full pl-10 pr-3 py-3 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-2 focus:ring-[var(--feel-primary)] focus:border-[var(--feel-primary)] transition-all duration-200"
              placeholder={t('CONTENT.keyword')}
              value={keyword}
              onChange={onKeywordChange}
            />
          </div>
        </div>

        <div className="w-full lg:flex-1">
          <div className="relative">
            <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
              <svg className="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
            </div>
            <input
              ref={addressRef}
              type="text"
              className="block w-full pl-10 pr-10 py-3 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-2 focus:ring-[var(--feel-primary)] focus:border-[var(--feel-primary)] transition-all duration-200"
              placeholder={t('CONTENT.nearby')}
              value={address}
              onChange={onAddressChange}
            />
            {address && (
              <button
                type="button"
                className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-400 hover:text-gray-600 transition-colors duration-200"
                onClick={onClearAddress}
                aria-label={t('GENERAL.close', 'Chiudi')}
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            )}
          </div>
        </div>

        <div className="w-full lg:w-auto lg:flex-shrink-0">
          <button
            type="button"
            className="w-full lg:w-auto px-6 py-3 text-white font-medium rounded-lg transition-all duration-200 hover:scale-105 bg-[var(--feel-primary)] hover:bg-[var(--feel-primary-dark)]"
            onClick={onSearch}
          >
            {t('YF_SEARCH.searchFor')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default BookSearchForm;
